import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { SigninSignupComponent } from './signin-signup/signin-signup/signin-signup.component';
import { AuthGuard } from './services/auth.guard';
import { PreviewComponent } from './preview/preview.component';
import { CreateTemplateComponent } from './master_modules/masters/apps/template/templates/create-template/create-template.component';
import { PreviewCurrentFileComponent } from './preview-current-file/preview-current-file.component';
import { PreviewSmmTemplateComponent } from './master_modules/masters/master-smm-templates/preview-smm-template/preview-smm-template.component';

const routes: Routes = [
  {
    path:'',
    component:SigninSignupComponent
  },
  {
    path: 'master',
    loadChildren: () =>
      import(
        './master_modules/master-config-mod/master-config-mod.module'
      ).then((module) => module.MasterConfigModModule),
      canActivate:[AuthGuard]
  },
  {
    path:'template/:id',
    component:PreviewComponent
  },
  {
    path:'page/:id',
    component:PreviewComponent
  },
  {
    path: 'create-template',
    component: CreateTemplateComponent
  },
  { path: 'master/smm-templates/template-preview', component: PreviewSmmTemplateComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes,{preloadingStrategy: PreloadAllModules })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
